"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _remark = _interopRequireDefault(require("remark"));

var _remarkParse = _interopRequireDefault(require("remark-parse"));

var _remarkReact = _interopRequireDefault(require("remark-react"));

var CarouselImage = function CarouselImage(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "full-width-image margin-top-0",
      style: {
        backgroundImage: "url(".concat(!!props.image.childImageSharp ? props.image.childImageSharp.fluid.src : props.image, ")"),
        backgroundPosition: "center center",
        padding: "300px 0px",
        position: "relative",
        maxWidth: "100%"
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "background-overlay",
      style: {
        backgroundColor: "#000000",
        opacity: "0.4"
      }
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "has-text-centered has-text-white-ter",
      style: {
        display: "flex",
        height: "50px",
        lineHeight: "1",
        justifyContent: "space-around",
        alignItems: "center",
        flexDirection: "column",
        zIndex: 1
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "is-size-7-mobile is-size-7-tablet is-size-3-widescreen",
      style: {
        paddingLeft: "5rem",
        paddingRight: "5rem",
        paddingBottom: "1.5rem"
      }
    }, (0, _remark["default"])().use(_remarkParse["default"]).use(_remarkReact["default"]).processSync("".concat(props.title)).contents)),
    /*#__PURE__*/
    _react["default"].createElement("div", null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "is-size-11-mobile is-size-11-tablet is-size-9-widescreen",
      style: {
        paddingLeft: "5rem",
        paddingRight: "5rem",
        paddingBottom: "1.5rem"
      }
    }, (0, _remark["default"])().use(_remarkParse["default"]).use(_remarkReact["default"]).processSync("".concat(props.text)).contents)))))
  );
};

var _default = CarouselImage;
exports["default"] = _default;